import { BORDER_RADII } from 'enums/configuration';

export default function getRadius(radiiType, smallAmount, largeAmount) {
  let radiiMap = {
    [BORDER_RADII.NONE]: 0,
    [BORDER_RADII.LARGE]: largeAmount,
    [BORDER_RADII.SMALL]: smallAmount,
  };

  return (radiiMap[radiiType] || 0).toString() + 'px';
}
